import { restApi } from '../../api/restApiSlice';

export const gscApi = restApi.injectEndpoints({
  tagTypes: ['GscIntegration'],
  endpoints: (builder) => ({
    getGscIntegrationsStatus: builder.query({
      query: () => '/v3/gsc-integrations/status',
      providesTags: ['GscIntegration'],
    }),
    getGscSitemaps: builder.query({
      query: () => `/v3/gsc-integrations/sitemaps`,
      // providesTags also runs for rejected queries, with result undefined
      providesTags: (result) => [
        'GscIntegration',
        ...(result?.data?.items ?? []).map(({ url }) => ({ type: 'GscIntegration', id: url })),
      ],
    }),
    createGscIntegration: builder.mutation({
      query: (dto) => ({
        url: '/v3/gsc-integrations',
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: ['GscIntegration'],
    }),
    deleteGscIntegration: builder.mutation({
      query: () => ({
        url: '/v3/gsc-integrations',
        method: 'DELETE',
      }),
      invalidatesTags: ['GscIntegration'],
    }),
    importGscSitemap: builder.mutation({
      query: (dto) => ({
        url: '/v3/gsc-integrations/sitemaps/imports',
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: ['GscIntegration'],
    }),
  }),
});

export const {
  useGetGscIntegrationsStatusQuery,
  useGetGscSitemapsQuery,
  useCreateGscIntegrationMutation,
  useDeleteGscIntegrationMutation,
  useImportGscSitemapMutation,
} = gscApi;
